import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import {
    Container,
    Box,
    Typography,
    TextField,
    CircularProgress,
    Button,
    Stack,
} from '@mui/material';
import { 
    ConfigContext,
} from '../../Config/ConfigContext';
import useForm from '../../hooks/useForm';
import http from '../../utils/http';
import { debounce } from 'lodash';

const saveField = debounce(async (data, uri) => {
    await http.put(data, uri);
}, 500);

const onLoad = async ({ values }) => {
    const emailLog = await http.get({}, `${values.config.uri.base}/email-log/${values._id}`);
    return {
        ...values,
        ...emailLog,
        loading: false,
    };
};

export default function EmailLogDetail() {
    const { emailLogId } = useParams();
    const { config } = useContext(ConfigContext);
    const { state, onChange } = useForm({
        debug: true,
        initialState: {
            config,
            _id: emailLogId,
            emailTemplateId: '',
            accepted: [],
            rejected: [],
            ehlo: [],
            envelopeTime: 0,
            messageTime: 0,
            messageSize: 0,
            response: '',
            envelope: {
                from: '',
                to: [],
            },
            messageId: '',
            createdAt: null,
            loading: true,
        },
        onLoad
    });

    const handleDelete = async () => {
        await http.delete({}, `${config.uri.base}/email-log/${state.values._id}`);
        window.location.href = '/email-logs';
    };

    return (
        <Container>
            {state.values.loading ? (
                <CircularProgress />
            ) : (
                <>
                    <Box sx={{ marginTop: '20px' }}>
                        <Typography variant="h5">Email Log Details</Typography>
                        <Stack spacing={2} sx={{ marginTop: '20px' }}>
                            <TextField
                                label="Email Template ID"
                                value={state.values.emailTemplateId}
                                onChange={(e) => {
                                    onChange(e.target.value, 'emailTemplateId');
                                    saveField({ emailTemplateId: e.target.value }, `${config.uri.base}/email-log/${state.values._id}`);
                                }}
                                fullWidth
                            />
                            <TextField
                                label="Accepted"
                                value={state.values.accepted.join(', ')}
                                onChange={(e) => {
                                    const value = e.target.value.split(', ');
                                    onChange(value, 'accepted');
                                    saveField({ accepted: value }, `${config.uri.base}/email-log/${state.values._id}`);
                                }}
                                fullWidth
                            />
                            <TextField
                                label="Rejected"
                                value={state.values.rejected.join(', ')}
                                onChange={(e) => {
                                    const value = e.target.value.split(', ');
                                    onChange(value, 'rejected');
                                    saveField({ rejected: value }, `${config.uri.base}/email-log/${state.values._id}`);
                                }}
                                fullWidth
                            />
                            <TextField
                                label="Envelope Time"
                                value={state.values.envelopeTime}
                                onChange={(e) => {
                                    onChange(e.target.value, 'envelopeTime');
                                    saveField({ envelopeTime: e.target.value }, `${config.uri.base}/email-log/${state.values._id}`);
                                }}
                                fullWidth
                            />
                            <TextField
                                label="Message Time"
                                value={state.values.messageTime}
                                onChange={(e) => {
                                    onChange(e.target.value, 'messageTime');
                                    saveField({ messageTime: e.target.value }, `${config.uri.base}/email-log/${state.values._id}`);
                                }}
                                fullWidth
                            />
                            <TextField
                                label="Message Size"
                                value={state.values.messageSize}
                                onChange={(e) => {
                                    onChange(e.target.value, 'messageSize');
                                    saveField({ messageSize: e.target.value }, `${config.uri.base}/email-log/${state.values._id}`);
                                }}
                                fullWidth
                            />
                            <TextField
                                label="Response"
                                value={state.values.response}
                                onChange={(e) => {
                                    onChange(e.target.value, 'response');
                                    saveField({ response: e.target.value }, `${config.uri.base}/email-log/${state.values._id}`);
                                }}
                                fullWidth
                            />
                        </Stack>
                    </Box>
                    <Box sx={{ marginTop: '20px' }}>
                        <Typography variant="h6">Read-Only Fields</Typography>
                        <Stack spacing={2}>
                            <Typography><strong>ID:</strong> {state.values._id}</Typography>
                            <Typography><strong>Envelope From:</strong> {state.values.envelope.from}</Typography>
                            <Typography><strong>Envelope To:</strong> {state.values.envelope.to.join(', ')}</Typography>
                            <Typography><strong>Message ID:</strong> {state.values.messageId}</Typography>
                            <Typography><strong>EHLO:</strong> {state.values.ehlo.join(', ')}</Typography>
                            <Typography><strong>Created At:</strong> {state.values.createdAt}</Typography>
                        </Stack>
                    </Box>
                    <Box sx={{ marginTop: '20px' }}>
                        <Button variant="contained" color="error" onClick={handleDelete}>
                            Delete Email Log
                        </Button>
                    </Box>
                </>
            )}
        </Container>
    );
}
